export default {
    status: {
        acknowledged: "Zamówione",
        created: "Stworzony",
        sent: "Zamówione",
        confirmed: "Zamówione",
        not_confirmed: "Nie zamówiono",
        delivery_email: "Wysłany",
        delivery_rejected: "Wyjątek dostawy",
        delivery_rejected_not_confirmed: "Wyjątek dostawy",
        shipped: "Wysłany",
        delayed: "Opóźniony",
        preparing: "Przygotowanie",
        processing: "Przetwarzanie",
        processed: "Obrobiony",
        submitted: "Zamówione",
        delivery_not_received: "Wysłany",
        shipment_exception: "Wysłany",
        pre_pending_approval: "Aż do",
        pending_approval: "Aż do",
        approved: "Zatwierdzony",
        not_approved: "Niezatwierdzone",
        canceled: "Odwołany",
        returned: "Zwrócony",
        lost_shipment: "Zaginiona przesyłka",
        delivery_not_confirmed: "Dostarczony",
        delivered: "Dostarczony",
        delivery_received: "Dostarczony",
        refurbished: "Zwrot zakończony",
        returned_to_office: "Wrócił do biura",
        return_to_employer: "Zwrócone pracodawcy",
        return_pickup_scheduled: "Odbiór zaplanowany",
        return_pickup_completed: "Odbiór zakończony",
        return_pickup_excluded: "Odbiór nie jest możliwy",
        return_pickup_submitted: "Odbiór przesłany",
        return_pickup_finalized: "Odbiór sfinalizowany",
        disposed: "Wyrzucony",
        damaged: "Uszkodzony",
        transferred: "Przeniesiony",
        transfer_received: "Otrzymano przelew"
    }
}